import { Divider } from '@mui/material';

import FlowsView from '@components/Flows/FlowsView';
import UnhandledErrors from '@components/Flows/UnhandledErrors';

import s from './FlowsPage.module.css';

function FlowsPage() {
  return (
    <div className={s.chargerFlowsContainer}>
      <UnhandledErrors />
      <Divider />
      <FlowsView />
    </div>
  );
}

export default FlowsPage;
